import React from 'react';
import s from './s.modules.less';
import Frame from './frame.png';
import CommonTable from 'components/CommonTable';
import { Button } from 'antd';
import WebinarBooking from 'components/WebinarBooking';
import { CALENDLY_LINK } from 'constants/common';
import { EWebinarScheduleType } from 'types/common';

const Fee = () => {
    const [data, setData] = React.useState<any[]>([]);
    const [showWebinar, setShowWebinar] = React.useState(false);
    React.useEffect(() => {
        setData([
            {
                payback: '≤ 30 days',
                fee: '2.0%',
                promo: '1.3%',
            },
            {
                payback: '30–60 days',
                fee: '3.5%',
                promo: '3.0%',
            },
            {
                payback: '60–90 days',
                fee: '5.0%',
                promo: '4.3%',
            },
        ]);
    }, []);

    const columns = [
        {
            title: 'PAYBACK PERIOD',
            dataIndex: 'payback',
            key: 'payback',
            width: 225,
        },
        {
            title: 'MONTHLY FEE',
            dataIndex: 'fee',
            key: 'fee',
            width: 225,
        },
        {
            title: 'PROMO RATE FOR PRACTICES SIGNED BEFORE DEC 31, 2025 (VALID FOR ≥12 MONTHS)',
            dataIndex: 'promo',
            key: 'promo',
        },
    ];
    const handleTalk = () => {
        setShowWebinar(true);
    };

    return (
        <div className={s.howItWordsWrap}>
            <div className={s.title}>Flexible repayment & fees</div>
            <div className={s.des}>All capital and fees must be repaid within time period of accepted offer.</div>
            <div className={s.tableWrap}>
                <CommonTable
                    data={data}
                    columns={columns}
                    pagination={false}
                    bordered
                    rowKey="payback"
                />
            </div>
            <div className={s.title}>Requirements to apply</div>
            <ul className={s.requirementsList}>
                <li>A valid government-issued photo ID.</li>
                <li>Recent business tax returns in PDF format, covering the past two years or more.</li>
                <li>Securely connect your business bank account via Plaid to speed up the approval process.</li>
                <li>Alternatively, we allow you to submit 6 months of bank statements if you prefer not to connect your bank account.</li>
            </ul>
            <div><i>* Eligible providers may receive between $500–$10,000, depending on financial review and approval.</i></div>
            <div className={s.btnWrap}>
                <Button
                    onClick={handleTalk}
                    className={s.btn}
                    type="primary"
                    size="large"
                >
                    Talk to a Klarity specialist
                </Button>
            </div>
            <WebinarBooking
                show={showWebinar}
                link={CALENDLY_LINK.FINANCIALS_SPECIALIST}
                webinarScheduleType={EWebinarScheduleType.PRO_LISTINGS_SPECIALIST}
                onClose={(isSuccess) => {
                    setShowWebinar(false);
                }}
            />
        </div>
    );
};

export default Fee;
